import React from 'react';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';

// Lands directly on the pricing content. Pricing already carries its own
// heading, so there is no separate (repeated) page title.
export function PricingPage() {
  return <div data-id="element-654" data-mp="4z2ihwnplisa">
      <Pricing data-id="element-655" data-mp="9vsy6ivlqcd6" />
      <FAQ data-id="element-656" data-mp="9v9eawme5dwi" />
    </div>;
}